export function validPTCELL(cell) {
	var patt = new RegExp(/^9(1|2|3|6)[0-9]{7}$/gm);
	return patt.test(cell);
}

export function validPTLANDLINE(landline) {
	var patt = new RegExp(/^2[0-9]{8}$/gm);
	return patt.test(landline);
}

export function validPTVATIN(vatin) {
	var validLeads = ["1", "2", "3", "45", "5", "6", "70", "71", "72", "77", "79", "8", "90", "91", "98", "99"];

	var validlead = validLeads.some(function (lead) {
		return vatin.indexOf(lead) == 0
	});
	if (!validlead) {
		return false;
	}

	var numbers = vatin.split("").map(function (itm) {
		return parseInt(itm)
	});
	var controlsum = 0;

	for (var f = 0; f <= 7; f++) {
		controlsum += numbers[f] * (9 - f);
	}

	var mod1 = controlsum - parseInt(controlsum / 11) * 11;
	if (numbers[8] != ((mod1 == 1 || mod1 == 0) ? 0 : 11 - mod1)) {
		return false;
	}

	return true;
}

export function validPOSTALCODE(postalcode) {
	var patt = new RegExp(/^[0-9][0-9][0-9][0-9]-[0-9][0-9][0-9]$/gm);
	return patt.test(postalcode);
}

export function validEMAIL(email) {
	var patt = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+(com|pt)))$/);
	return patt.test(email);
}

export function validNAME(value) {
	return /^([\w\W\-'.]+) ([\w\W\-'.]+)/i.test(value);
}

export function validFILLED(value) {
	// console.log(value);
	return value.length > 2;
}